import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const highlighterDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'highlighterTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the HighlighterTestkit unidriver testkit instead.',
  );

  return {
    exists: () => !!element,
    html: () => element.innerHTML,
    getElement: () => element,
  };
};

export { highlighterDriverFactory };
